  <script setup>

  const props = defineProps({
    HeziyunData: {
      type: Object,
      default: () => ({})
    }
  })

  const showLoading = ref(true)
  const isFadeOut = ref(false)

  let timer = null
  let fadeTimer = null
  let locked = false

  const clearTimers = () => {
    clearTimeout(timer)
    clearTimeout(fadeTimer)
    timer = null
    fadeTimer = null
  }

  const lockScroll = () => {
    if (locked) return
    locked = true
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
  }

  const unlockScroll = () => {
    if (!locked) return
    locked = false
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
  }

  const globalAnimation = computed(() => {
    return props.HeziyunData?.globalcode?.global_animation || ''
  })

  const closeLoading = () => {
    isFadeOut.value = true

    fadeTimer = setTimeout(() => {
      showLoading.value = false
      unlockScroll()
    }, 100)
  }

  watch(
    globalAnimation,
    (val) => {
      clearTimers()

      // 没有动画配置直接隐藏组件
      if (!val) {
        showLoading.value = false
        isFadeOut.value = false
        unlockScroll()
        return
      }

      showLoading.value = true
      isFadeOut.value = false
      lockScroll()

      timer = setTimeout(() => {
        closeLoading()
      }, 1500)
    },
    { immediate: true }
  )

  onBeforeUnmount(() => {
    clearTimers()
    unlockScroll()
  })
</script>

  <template>
    <!-- 有自定义动画 -->
    <div v-if="showLoading" class="Heziyun-loader-wrapper" :class="{ 'fade-out': isFadeOut }" v-html="globalAnimation">
    </div>
  </template>

<style lang="less">
.Heziyun-loader-wrapper {
  transition: opacity 0.5s ease;
  opacity: 1;
}

.Heziyun-loader-wrapper.fade-out {
  opacity: 0;
  pointer-events: none;
}

.Heziyun-loader-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  color: #262626;
  user-select: none;
  gap: 10px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 9999;
  background-color: #fff;

  .loader {
    width: 20px;
    height: 20px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    background-color: transparent;
    animation: loader-rotate 1.5s linear infinite;
    z-index: 0;
  }

  @keyframes loader-rotate {
    0% {
      transform: rotate(90deg);
      box-shadow:
        0 1px 1px 0 #fff inset,
        0 3px 5px 0 #ff2b2b inset,
        0 4px 4px 0 #ff0606 inset;
    }

    50% {
      transform: rotate(270deg);
      background: #ffe8e9;
      box-shadow:
        0 1px 1px 0 #ffc8c8 inset,
        0 3px 5px 0 #ff1b1b inset,
        0 4px 4px 0 #fbef19 inset;
    }

    100% {
      transform: rotate(450deg);
      box-shadow:
        0 1px 1px 0 #fff inset,
        0 3px 5px 0 #ff8f8f inset,
        0 4px 4px 0 #ff1b1b inset;
    }
  }

  .letter-wrapper {
    display: flex;
    gap: 1px;
  }

  .loader-letter {
    display: inline-block;
    opacity: 0.4;
    transform: translateY(0);
    animation: loader-letter-anim 2s infinite;
    z-index: 1;
    border-radius: 50ch;
    border: none;
  }

  .loader-letter:nth-child(1) {
    animation-delay: 0s;
  }

  .loader-letter:nth-child(2) {
    animation-delay: 0.1s;
  }

  .loader-letter:nth-child(3) {
    animation-delay: 0.2s;
  }

  .loader-letter:nth-child(4) {
    animation-delay: 0.3s;
  }

  .loader-letter:nth-child(5) {
    animation-delay: 0.4s;
  }

  .loader-letter:nth-child(6) {
    animation-delay: 0.5s;
  }

  .loader-letter:nth-child(7) {
    animation-delay: 0.6s;
  }

  .loader-letter:nth-child(8) {
    animation-delay: 0.7s;
  }

  .loader-letter:nth-child(9) {
    animation-delay: 0.8s;
  }

  .loader-letter:nth-child(10) {
    animation-delay: 0.9s;
  }

  @keyframes loader-letter-anim {

    0%,
    100% {
      opacity: 0.4;
      transform: translateY(0);
    }

    20% {
      opacity: 1;
      transform: scale(1.15);
    }

    40% {
      opacity: 0.7;
      transform: translateY(0);
    }
  }
}
</style>